import { Component } from '@angular/core';
import { AppConstants } from '../../../app.constants';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent {
   public AppVersion : string = (<any>window)[AppConstants.AppVersion];

}
